import styled from "@emotion/styled";
import React from "react";
import { baseInputCss } from "./Question";
import QuestionWrapper from "./QuestionWrapper";

function QuestionInput(
  props: React.ComponentPropsWithRef<typeof QuestionInput.Styled> & JSX.IntrinsicElements["input"],
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <QuestionWrapper>
      <QuestionInput.Styled role="textbox" aria-label={props.name} ref={ref} {...props} />
    </QuestionWrapper>
  );
}

QuestionInput.Styled = styled.input`
  ${baseInputCss}
`;

export default Object.assign(React.forwardRef(QuestionInput), {
  Styled: QuestionInput.Styled,
});
